export class LogSearchCriteria {
  public PageSize: Number;
  public Filter: string;
  public PartitionKey: string;
  public RowKey: string;
}
